<template>
  <apexchart
    class="score-chart-current"
    width="339px"
    type="radialBar"
    :options="optionsCurrent"
    :series="seriesCurrent"
  />
  <apexchart
    width="339px"
    type="radialBar"
    :options="optionsPotential"
    :series="seriesPotential"
  />
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    currentScore?: number;
    potentialScore?: number;
    totalScore?: number;
    pcntScore?: number;
    color: string;
    colorDefault: string;
  }>(),
  {
    currentScore: 0,
    potentialScore: 0,
    totalScore: 1,
    pcntScore: 0,
  },
);

const optionsCurrent = computed(() => ({
  colors: [props.color],
  plotOptions: {
    radialBar: {
      startAngle: -90,
      endAngle: 90,
      hollow: {
        size: "70%",
      },
      track: {
        background: props.colorDefault,
        startAngle: -90,
        endAngle: 90,
        show: true,
      },
      dataLabels: {
        name: {
          show: false,
          offsetY: 0,
        },
        value: {
          color: props.color,
          fontSize: "50px",
          fontWeight: 500,
          show: true,
          offsetY: 0,
          formatter: () => `${toFixed(props.pcntScore)}%`,
        },
      },
    },
  },
  stroke: {
    lineCap: "round",
    opacity: 1,
  },
  fill: {
    opacity: 1,
  },
  labels: ["current"],
}));

const optionsPotential = {
  colors: ["#FEE5E2"],
  plotOptions: {
    radialBar: {
      startAngle: -90,
      endAngle: 90,
      hollow: {
        size: "70%",
      },
      track: {
        background: "#F1F2F3",
        startAngle: -90,
        endAngle: 90,
      },
      dataLabels: {
        name: {
          show: false,
          offsetY: 0,
        },
        value: {
          color: "#211F58",
          fontSize: "50px",
          fontWeight: 500,
          show: false,
          offsetY: 0,
        },
      },
    },
  },
  stroke: {
    lineCap: "round",
  },
  labels: ["potential"],
};

const seriesCurrent = computed(() => {
  const current = toFixed((props.currentScore * 100) / props.totalScore);
  return [current];
});

const seriesPotential = computed(() => {
  const potential = toFixed((props.potentialScore * 100) / props.totalScore);
  return [potential];
});

const toFixed = (num: number, digit = 2) => {
  let output = (num || 0).toFixed(digit);
  while (output[output.length - 1] === "0") {
    output = output.slice(0, -1);
  }
  if (output[output.length - 1] === ".") {
    output = output.slice(0, -1);
  }
  return output;
};
</script>

<style scoped lang="scss">
.score-chart-current {
  position: absolute;
  z-index: 1;
  &:deep(text[class*="apexcharts-text"]) {
    position: relative;
    &::after {
      content: "%";
      vertical-align: super;
      font-size: smaller;
    }
  }
}
</style>
